import * as LoginType from "../../action/actiontype/LoginType/LoginType.jsx";

const loginReducer = (state = {}, action) => {
    switch (action.type) {
        case LoginType.LOGIN_REQUEST:
            return {
                ...state,
                loginLoading: true,
                loginResponse: {},
                loginError: null
            }
        case LoginType.LOGIN_SUCCESS:
            return {
                ...state,
                loginLoading: false,
                loginResponse: action.payload,
                loginError: null
            }
        case LoginType.LOGIN_FAILURE:
            return {
                ...state,
                loginLoading: false,
                loginError: action.payload,
                loginResponse: {}
            }
            // VERIFY OTP
        case LoginType.VERIFY_REQUEST:
            return {
                ...state,
                verifyOtpLoading: true,
                verifyOtpResponse: {},
                verifyOtpError: null
            }
        case LoginType.VERIFY_SUCCESS:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpResponse: action.payload,
                verifyOtpError: null
            }
        case LoginType.VERIFY_FAILURE:
            return {
                ...state,
                verifyOtpLoading: false,
                verifyOtpResponse: action.payload,
                verifyOtpError: {}
            }
            // FORGOT PASSWORD
            case LoginType.FORGOTPASSWORD_REQUEST:
                return {
                    ...state,
                    forgotPasswordLoading: true,
                    forgotPasswordResponse: {},
                    forgotPasswordError: null
                }
            case LoginType.FORGOTPASSWORD_SUCCESS:
                return {
                    ...state,
                    forgotPasswordLoading: false,
                    forgotPasswordResponse: action.payload,
                    forgotPasswordError: null
                }
            case LoginType.FORGOTPASSWORD_FAILURE:
                return {
                    ...state,
                    forgotPasswordLoading: false,
                    forgotPasswordResponse: action.payload,
                    forgotPasswordError: {}
                }
            // CHNAGE PASSWORD

            case LoginType.CHANGEPASSWORD_REQUEST:
                return {
                    ...state,
                    changePasswordLoading: true,
                    changePasswordResponse: {},
                    changePasswordError: null
                }
            case LoginType.CHNAGEPASSWORD_SUCCESS:
                return {
                    ...state,
                    changePasswordLoading: false,
                    changePasswordResponse: action.payload,
                    changePasswordError: null
                }
            case LoginType.CHANGEPASSWORD_FAILURE:
                return {
                    ...state,
                    changePasswordLoading: false,
                    changePasswordResponse: action.payload,
                    changePasswordError: {}
                }
            // send otp
            case LoginType.SENDOTP_REQUEST:
                return {
                    ...state,
                    sendOtpLoading: true,
                    sendOtpResponse: {},
                    sendOtpError: null
                }
            case LoginType.SENDOTP_SUCCESS:
                return {
                    ...state,
                    sendOtpLoading: false,
                    sendOtpResponse: action.payload,
                    sendOtpError: null
                }
            case LoginType.SENDOTP_FAILURE:
                return {
                    ...state,
                    sendOtpLoading: false,
                    sendOtpResponse: action.payload,
                    sendOtpError: {}
                }
        default:
            return state;
    }
}

export default loginReducer;